import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import "./InspectPdfModal.css";

class InspectPdfModal extends React.Component {
  constructor(props) {
    super(props);
    this.closeInspectModal = this.closeInspectModal.bind(this);
    this.flattenClicked = this.flattenClicked.bind(this);
    this.diffClicked = this.diffClicked.bind(this);
    this.pdfClicked = this.pdfClicked.bind(this);

    this.state = {
      mode: null,

      loadedImageUri: null,
      loadedDiffImageUri: null
    };
  }

  flattenClicked() {
    const { flattenClicked } = this.props;
    this.closeInspectModal();
    flattenClicked();
  }

  diffClicked() {
    this.setState({ mode: null });
  }

  pdfClicked() {
    const { mode } = this.state;

    if (mode === "pdf") {
      this.setState({ mode: "html" });
    } else {
      this.setState({ mode: "pdf" });
    }
  }

  closeInspectModal() {
    this.props.closeModal();
  }

  render() {
    const { mode, loadedImageUri, loadedDiffImageUri } = this.state;

    let curTitle = "Diff";
    if (mode === "pdf") {
      curTitle = "Pdf";
    } else if (mode === "html") {
      curTitle = "Html";
    }

    const { pageImageUri, diffImageUri, page, showInspectModal } = this.props;

    let htmlClass = "inspect_diff_page_image";

    if (mode === "html") {
      htmlClass = "inspect_diff_page_image_original";
    }

    return (
      <Modal
        size="lg"
        show={showInspectModal}
        onHide={this.closeInspectModal}
        centered
      >
        <Modal.Body>
          {loadedImageUri !== pageImageUri && (
            <div className="inspect_single_pdf_spinner_container">
              <Spinner animation="grow" />
            </div>
          )}
          <Container>
            <Row>
              <Col xs="10" sm="10" md="10" lg="11" xl="11">
                <div className="inspect_single_pdf_img_area inspect_single_pdf_images">
                  <img
                    style={
                      loadedImageUri === pageImageUri ? {} : { display: "none" }
                    }
                    className="inspect_pdf_page_image"
                    src={pageImageUri}
                    alt=""
                    ref={this.pdfImage}
                    onLoad={() =>
                      this.setState({ loadedImageUri: pageImageUri })
                    }
                  />
                  <img
                    style={
                      loadedDiffImageUri === diffImageUri &&
                      (mode === "html" || mode == null)
                        ? {}
                        : { display: "none" }
                    }
                    className={htmlClass}
                    ref={el => (this.htmlImage = el)}
                    src={diffImageUri}
                    alt=""
                    onLoad={() =>
                      this.setState({ loadedDiffImageUri: diffImageUri })
                    }
                  />
                </div>
              </Col>
              <Col xs="2" sm="2" md="2" lg="1" xl="1">
                <br />
                <br />
                <br />我<br />現<br />在<br />是<br />
                <br /> {curTitle}
                <Button
                  variant="info"
                  onClick={this.diffClicked}
                  style={{ margin: 0, marginTop: "150px" }}
                >
                  Diff
                </Button>
                <Button
                  variant="info"
                  onClick={this.pdfClicked}
                  style={{ margin: 0, marginTop: "10px" }}
                >
                  <span class="fa fa-exchange" />
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.closeInspectModal}>
            Close
          </Button>
          <Button
            variant="info"
            disabled={page.should_flatten}
            onClick={this.flattenClicked}
          >
            {`Flatten page ${page.page_num}`}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default InspectPdfModal;
